webpackJsonp([205],{

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "Vue + webpack 区分测试环境和生产环境 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1965:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1150),
  /* template */
  __webpack_require__(2392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/vue-webpack-env-165.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-webpack-env-165.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-926f985e", Component.options)
  } else {
    hotAPI.reload("data-v-926f985e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2392:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("区分测试环境和生产环境")]), _vm._v(" "), _c('p', [_vm._v("如果你使用了 "), _c('code', [_vm._v("vux2")]), _vm._v(" 模板或者 "), _c('code', [_vm._v("webpack")]), _vm._v(" 模板，默认你可以直接通过判断 "), _c('code', [_vm._v("process.env.NODE_ENV")]), _vm._v(" 来区分")]), _vm._v(" "), _c('p', [_vm._v("比如"), _c('code', [_vm._v("统计代码")]), _vm._v("仅放在 "), _c('code', [_vm._v("production")]), _vm._v(" 环境，在不同环境里使用不同的 "), _c('code', [_vm._v("API")]), _vm._v(" 接口地址。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" (process.env.NODE_ENV === "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'production'")]), _vm._v(") {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 干一些线上才要做的事情")]), _vm._v("\n}\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("if")]), _vm._v(" (process.env.NODE_ENV === "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'development'")]), _vm._v(") {\n  "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 干一些测试时不可告人的事情")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你是自己配置的环境，可以参考 "), _c('a', {
    attrs: {
      "href": "https://webpack.js.org/plugins/define-plugin/"
    }
  }, [_vm._v("webpack DefinePlugin 文档")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-926f985e", module.exports)
  }
}

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1965);

/***/ })

});


// WEBPACK FOOTER //
// 205.3a9122d9.js